import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerRegistroRifiutiModalComponent} from './worker-registro-rifiuti-modal';

export const WorkerRegistroRifiutiModalModule: string = ng
    .module('worker-registro_rifiuti-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerRegistroRifiutiModalComponent', WorkerRegistroRifiutiModalComponent)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-registro-rifiuti-modal/worker-registro-rifiuti-modal.module.ts